import PropTypes from 'prop-types';

const useListStatusViewModel = ({ statuses, expanded }) => {
  return {
    expanded: expanded,
    statuses: statuses,
  };
};

useListStatusViewModel.propTypes = {
  statuses: PropTypes.array,
};

export default useListStatusViewModel;
